module.exports = __webpack_public_path__ + "mbg.png?b9dfffbd6ae98b307e384b103e613b1e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/mbg.png
// module id = 539
// module chunks = 0